import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { INSIDE_SLIDES } from '../data/inside';
import { scrollToBuy } from '../utils/constants';
export function InsideCarousel() {
  const [index, setIndex] = useState<number>(0);
  const total = INSIDE_SLIDES.length;
  const slide = INSIDE_SLIDES[index];
  const go = (direction: number) => setIndex(prev => (prev + direction + total) % total);
  return <section aria-labelledby="inside-title" className="w-full bg-soft px-3 py-6 sm:px-5" data-id="element-135" data-mp="2awce7oabokrl">
      <div className="mx-auto max-w-3xl" data-id="element-136" data-mp="2omze3jrtkgp9">
        <h2 id="inside-title" className="text-center font-head text-2xl uppercase leading-[0.98] text-navy sm:text-4xl" data-id="element-137" data-mp="2olxrci1fy5rp">
          Take a look inside Kids Learning Ready™
        </h2>

        <div className="mt-3 rounded-2xl border border-line bg-white p-2 sm:p-3" data-id="element-138" data-mp="2ymghfujlmii2">
          <div className="flex items-center justify-between gap-2" data-id="element-139" data-mp="2tmu1vegasq63">
            <button type="button" onClick={() => go(-1)} aria-label="Previous material" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy text-white transition-colors duration-150 ease-out hover:bg-blue" data-id="element-140" data-mp="2tkhcig87ndj0">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-141" data-mp="2wqyis0z0ni1n" />
            </button>

            <div className="min-w-0 flex-1 text-center" data-id="element-142" data-mp="30t1yj1spx8sq">
              <p className="font-head text-sm uppercase leading-none text-navy sm:text-lg" data-id="element-143" data-mp="30qp9k4ojly66">
                {slide.title}
              </p>
              <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-wide text-muted sm:text-[11px]" data-id="element-144" data-mp="3aq7ou7ticvrw">
                {slide.caption}
              </p>
            </div>

            <button type="button" onClick={() => go(1)} aria-label="Next material" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy text-white transition-colors duration-150 ease-out hover:bg-blue" data-id="element-145" data-mp="3kgj60w27d1gq">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-146" data-mp="3tiimnn9b23j5" />
            </button>
          </div>

          <button type="button" onClick={scrollToBuy} aria-label="Go to the purchase section" className="mt-2 block w-full overflow-hidden rounded-xl bg-soft" data-id="element-147" data-mp="1tg0zs7q8yvp0">
            <AnimatePresence mode="wait" initial={false} data-id="element-148" data-mp="234rb4a76fw0o">
              <motion.img key={slide.image} src={slide.image} alt={`${slide.title} printable visual cards sample`} loading="lazy" initial={{
              opacity: 0,
              scale: 0.98
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="mx-auto w-full" data-id="element-149" data-mp="236c620xelgz2" />
            </AnimatePresence>
          </button>

          <div className="mt-2 flex items-center justify-center gap-1.5" data-id="element-150" data-mp="2h2pjmyytgy89">
            {INSIDE_SLIDES.map((item, i) => <button key={item.title} type="button" onClick={() => setIndex(i)} aria-label={`Show ${item.title}`} aria-current={i === index} className={`h-2 rounded-full transition-colors duration-150 ease-out ${i === index ? 'w-6 bg-green' : 'w-2 bg-line hover:bg-muted'}`} data-id="element-151" data-mp="rrp3i4n22gsn" data-mpi={i} />)}
          </div>
        </div>
      </div>
    </section>;
}